import React, { useEffect } from 'react';
import { Link, useParams } from 'react-router-dom';
import { Button, Row, Col } from 'reactstrap';
import { Translate } from 'react-jhipster';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

import { APP_DATE_FORMAT, APP_LOCAL_DATE_FORMAT } from 'app/config/constants';
import { useAppDispatch, useAppSelector } from 'app/config/store';

import { getEntity } from './user-achivements.reducer';

export const UserAchivementsDetail = () => {
  const dispatch = useAppDispatch();

  const { id } = useParams<'id'>();

  useEffect(() => {
    dispatch(getEntity(id));
  }, []);

  const userAchivementsEntity = useAppSelector(state => state.userAchivements.entity);
  return (
    <Row>
      <Col md="8">
        <h2 data-cy="userAchivementsDetailsHeading">
          <Translate contentKey="fivePlusApp.userAchivements.detail.title">UserAchivements</Translate>
        </h2>
        <dl className="jh-entity-details">
          <dt>
            <span id="id">
              <Translate contentKey="global.field.id">ID</Translate>
            </span>
          </dt>
          <dd>{userAchivementsEntity.id}</dd>
          <dt>
            <span id="fileName">
              <Translate contentKey="fivePlusApp.userAchivements.fileName">File Name</Translate>
            </span>
          </dt>
          <dd>{userAchivementsEntity.fileName}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.userAchivements.user">User</Translate>
          </dt>
          <dd>{userAchivementsEntity.user ? userAchivementsEntity.user.id : ''}</dd>
          <dt>
            <Translate contentKey="fivePlusApp.userAchivements.achivements">Achivements</Translate>
          </dt>
          <dd>{userAchivementsEntity.achivements ? userAchivementsEntity.achivements.id : ''}</dd>
        </dl>
        <Button tag={Link} to="/user-achivements" replace color="info" data-cy="entityDetailsBackButton">
          <FontAwesomeIcon icon="arrow-left" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.back">Back</Translate>
          </span>
        </Button>
        &nbsp;
        <Button tag={Link} to={`/user-achivements/${userAchivementsEntity.id}/edit`} replace color="primary">
          <FontAwesomeIcon icon="pencil-alt" />{' '}
          <span className="d-none d-md-inline">
            <Translate contentKey="entity.action.edit">Edit</Translate>
          </span>
        </Button>
      </Col>
    </Row>
  );
};

export default UserAchivementsDetail;
